import Image from "next/image";
import { motion } from "framer-motion";
import quotesFlowerBorder from "../../../../public/images/t7-quote-flower.png";

const Quotes = () => {
  return (
    <div className="relative flex h-[20rem] items-center justify-center overflow-hidden border-b border-b-[#8C7756] px-4 shadow-[inset_0px_24px_84px_rgba(255,246,224,0.25)] sm:h-[40rem] sm:px-8">
      {/* Top Left Flower */}
      <div className="absolute top-[-120px] left-[-120px] z-0 rotate-90 scale-50 md:scale-100 lg:top-[-80px] lg:left-[-80px] lg:scale-100">
        <Image
          src={quotesFlowerBorder}
          alt="decorative flower"
          width={300}
          height={300}
          className="object-contain"
        />
      </div>

      {/* Top Right Flower */}
      <div className="absolute top-[-120px] right-[-120px] z-0 rotate-180 scale-50 md:scale-100 lg:top-[-80px] lg:right[-80px] lg:scale-100">
        <Image
          src={quotesFlowerBorder}
          alt="decorative flower"
          width={300}
          height={300}
          className="object-contain"
        />
      </div>

      {/* Main Content */}
      <div className="z-10 flex w-full flex-col items-center justify-center lg:w-1/2">
        <motion.div className="text-center">
          <motion.p
            initial={{ y: 100 }}
            animate={{
              y: 0,
              transition: {
                delay: 0.9,
                duration: 0.8,
                ease: [0.79, 0.14, 0.15, 0.86],
              },
            }}
            className="font-oceanTrace text-lg leading-[1.8] md:text-[2.5rem] md:leading-[78px]"
          >
            My heart is yours to hold <br />
            and cherish for the rest of our days.
          </motion.p>
        </motion.div>
      </div>

      {/* Bottom Left Flower */}
      <div className="absolute bottom-[-120px] left-[-120px] z-0 rotate-[270deg] scale-50 md:scale-100 lg:bottom-[-80px] lg:left-[-80px] lg:scale-100">
        <Image
          src={quotesFlowerBorder}
          alt="decorative flower"
          width={300}
          height={300}
          className="object-contain"
        />
      </div>

      {/* Bottom Right Flower */}
      <div className="absolute bottom-[-120px] right-[-120px] z-0 scale-50 md:scale-100 lg:bottom-[-80px] lg:right-[-80px] lg:scale-100">
        <Image
          src={quotesFlowerBorder}
          alt="decorative flower"
          width={300}
          height={300}
          className="object-contain"
        />
      </div>
    </div>
  );
};

export default Quotes;
